<div class="row template-strategy">
  <div class="medium-12 columns">
    <ng-template [ngIf]="template">
      <div foundation class="row reports">
        <div class="medium-10 columns" style="padding: 0;">
          <ul class="reports tabs" data-tabs id="report-tabs" style="padding: 0;">
            <li class="reports tabs-title" [ngClass]="{'is-active': currentView == 'strategies'}"><a id="a-strategies" (click)="switchPage('strategies')" aria-selected="true"><h6>Strategies</h6></a></li>
            <li class="reports tabs-title" [ngClass]="{'is-active': currentView == 'rates'}"><a id="a-rates"(click)="switchPage('rates')" aria-selected="false"><h6>Rates</h6></a></li>
            <li class="reports tabs-title" [ngClass]="{'is-active': currentView == 'fees'}"><a id="a-fees"(click)="switchPage('fees')" aria-selected="false"><h6>Fees</h6></a></li>
          </ul>
        </div>
        <div class="medium-2 columns text-right">
          <button style="margin-bottom: 0;" class="button small" (click)="applyTemplate()">Apply Template</button>
        </div>
        <div class="medium-12 columns">
          <div class="reports tabs-content" data-tabs-content="report-tabs" *ngIf="currentView == 'rates'">
            <ng-template [ngIf]="template.rates && template.rates.length == 0">
              <div class="body reveal-publish d-flex align-items-center justify-content-center" style="height: 10vh;">
                No rates added to this template.
              </div>
            </ng-template>
            <ng-template [ngIf]="template.rates && template.rates.length > 0">
              <div class="row mb-5 rate-line-item mt-3">
                <div class="medium-3 column" *ngFor="let item of template.rates;let index = index;">
                  <ng-template [ngIf]="!editing[index]">
                    <div class="text-center" >{{item.name}}</div>
                    <div class="text-center total-color pointer">
                      <span>{{item.rate}}%</span>
                      <span class="material-icons pointer edit-rate-icon" (click)="toggleField(index, true, item)">edit</span>
                      <span><i class="icon ion-ios-trash-outline" style="color: #F06459;" (click)="deleteRate(index)"></i></span>
                    </div>
                  </ng-template>
                  <ng-template [ngIf]="editing[index]">
                    <div class="text-center editing">
                      <label class="editing-label float-left">
                        <input type="text" placeholder="Rate name" [(ngModel)]="tempNames[index]"/>
                      </label>
                    </div>
                    <div class="text-center editing">
                      <label class="editing-label float-left">
                        <input type="text" placeholder="{{item.name}}" [(ngModel)]="temp[index]" model-numeral [format]="'0,0'" [locale]="'usd'"/>
                      </label>
                      <span class="material-icons pointer icon float-left" (click)="updateValue(index)">done</span>
                      <span class="material-icons pointer icon float-left" (click)="revertValue(index)">clear</span>
                    </div>
                  </ng-template>
                </div>
              </div>
            </ng-template>
          </div>
          <div class="reports tabs-content" data-tabs-content="report-tabs" *ngIf="currentView == 'fees'">
            <div class="row no-hover client-todos tax-strategy client-plans template-fees">
              <div class="medium-12 large-12 columns mt-3" style="padding: 0;" *ngIf="template.fees && template.fees.length > 0">
                <span style="color: #F06459;"><b>NOTE: </b> Please check each tab and fill in required info. In Fees: Associated With, Year are mandatory.</span>
              </div>
              <div class="medium-12 large-12 tpiq-paginated-table invoices scenarios mt-3"  style="height: 45vh;overflow-y: auto;">
                <table style="margin-top: 0 !important;">
                  <thead>
                  <tr>
                    <th *ngFor="let column of feesTableColumns">
                      <span>{{column.title}}</span>
                    </th>
                    <th class="pointer"></th>
                  </tr>
                  </thead>
                  <tbody>
                  <ng-template [ngIf]="template.fees && template.fees.length == 0">
                    <tr class="text-center">
                      <td [attr.colspan]="feesTableColumns.length">
                        <div class="callout text-center">
                          <p>No fees added to this template.</p>
                        </div>
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template [ngIf]="template.fees && template.fees.length > 0">
                    <tr *ngFor="let row of template.fees;let i = index;">
                      <td *ngFor="let col of feesTableColumns;let idx=index">
                        <div *ngIf="col.name == 'amount'">{{row[col.name]  | formatAmount:'$0,0'}}</div>
                        <div *ngIf="col.name != 'amount' && col.name != 'year' && col.name != 'associatedWithName'">{{row[col.name]}}</div>

                        <div class="action-dropdown list-item" *ngIf="col.name == 'associatedWithName'">
                          <app-tpiq-select-dropdown [setData]="associatedWith" [includeNone]="false" (onValueSelect)="setAssociatedWith($event, row)"
                                                 [setDefaultValue]="row['associatedWith']" [setSearchKey]="'name'" [setPlaceHolder]="'Associated With*'" [setValueKey]="'id'"></app-tpiq-select-dropdown>
                        </div>
                        <div class="action-dropdown list-item" *ngIf="col.name == 'year'">
                          <app-tpiq-select-dropdown [setData]="years" [includeNone]="false" (onValueSelect)="setYear($event, row)"
                                                 [setDefaultValue]="row[col.name]" [setSearchKey]="'name'" [setPlaceHolder]="'Year*'" [setValueKey]="'id'"></app-tpiq-select-dropdown>
                        </div>
                      </td>
                      <td>
                        <div class='badge-tooltip'>
                          <a class='action' data-action='delete'><span class='todo-del' (click)="deleteFees(i)"><i class="material-icons delete">delete</i></span></a>
                        </div>
                      </td>
                    </tr>
                  </ng-template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="reports tabs-content" data-tabs-content="report-tabs" *ngIf="currentView == 'strategies'">
            <div class="medium-12 mt-3" *ngIf="template.strategies && template.strategies.length > 0">
              <span style="color: #F06459;"><b>NOTE: </b>Please check each tab and fill in required info. In strategies: Payor, Fed Associated With, Begin are mandatory.</span>
            </div>
            <div class="medium-12 columns mt-3" style="padding: 0;">
              <app-template-strategies [planYear]="planYear" [strategies]="template.strategies" [clients]="clients" [allAssociatedData]="allAssociatedData" [allStateAssociatedData]="stateAssociatedData" [templateRates]="templateRates"></app-template-strategies>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
